import Vue    from 'vue'
import Router from 'vue-router'

// Login
import Login      from './components/Login.vue'
import Register   from './components/Register.vue'

// Profil
import Profil          from './components/profil/Profil.vue'
import VytvorenieFarmy from './components/profil/VytvorenieFarmy.vue'
import Kravicky        from './components/profil/Kravicky.vue'
import UpravaKravicky  from './components/profil/UpravaKravicky.vue'
import Aktivita        from './components/profil/Aktivita.vue'
import Statistiky      from './components/profil/Statistiky.vue'
import Spravy          from './components/profil/Spravy.vue'
import Heslo           from './components/profil/Heslo.vue'
import Udaje           from './components/profil/Udaje.vue'

// Kravicka
import KravickaDashboard from './components/kravicka/Kravicka.vue'
import KravickaObchod    from './components/kravicka/Obchod.vue'
import KravickaZmenaren  from './components/kravicka/Zmenaren.vue'
import KravickaSatnik    from './components/kravicka/Satnik.vue'

// Adopcia
import AdopciaUdaje from './components/adopcia/Udaje.vue'
import AdopciaEan   from './components/adopcia/Ean.vue'
import AdopciaInfo  from './components/adopcia/Info.vue'

// Album
import AlbumUspechy  from './components/album/Uspechy.vue'
import AlbumKravicky from './components/album/Kravicky.vue'
import AlbumAnatomia from './components/album/Anatomia.vue'
import AlbumRecepty  from './components/album/Recepty.vue'
import AlbumReceptyDetail from './components/album/DetailReceptu.vue'
import AlbumOmalovanky    from './components/album/Omalovanky.vue'
import AlbumVideosekcia   from './components/album/Videosekcia.vue'

// Pexeso
import PexesoLanding from "./components/pexeso/PexesoLanding.vue"
import PexesoGame from "./components/pexeso/PexesoGame.vue";
import PexesoLeaders from "./components/pexeso/PexesoLeaders.vue";
import PexesoSettings from "./components/pexeso/PexesoSettings.vue";

// Slider Puzzle
import SliderLanding from "./components/slider-puzzle/SliderLanding.vue";
import SliderGame from "./components/slider-puzzle/SliderGame.vue";
import SliderSettings from "./components/slider-puzzle/SliderSettings.vue";
import SliderLeaders from "./components/slider-puzzle/SliderLeaders.vue";

// Fallback page
// import PageNotFound from '@/components/profil/PageNotFound'

Vue.use(Router)

export default new Router({
    // mode: 'history',
    routes: [
    // Login
        {
            path: '/',
            name: 'login',
            component: Login,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/registracia',
            name: 'register',
            component: Register,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },


    // Profil
        {
            path: '/profil',
            name: 'profil',
            component: Profil,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/vytvorenie-farmy',
            name: 'vytvorenie-farmy',
            component: VytvorenieFarmy,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/kravicky',
            name: 'kravicky',
            component: Kravicky,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/uprava-kravicky/:kravicka_id?',
            name: 'uprava-kravicky',
            props: true,
            component: UpravaKravicky,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/aktivita',
            name: 'aktivita',
            component: Aktivita,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/statistiky',
            name: 'statistiky',
            component: Statistiky,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/spravy',
            name: 'spravy',
            component: Spravy,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/heslo',
            name: 'heslo',
            component: Heslo,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/udaje',
            name: 'udaje',
            component: Udaje,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },


    // Kravicka
        {
            path: '/kravicka/:kravicka_id?',
            name: 'kravicka',
            component: KravickaDashboard,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/kravicka/obchod/:kategoria/:kravicka_id?',
            name: 'obchod',
            component: KravickaObchod,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/kravicka/zmenaren/:kravicka_id?',
            name: 'zmenaren',
            component: KravickaZmenaren,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/kravicka/satnik/:kravicka_id?',
            name: 'satnik',
            component: KravickaSatnik,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },


    // Adopcia
        {
            path: '/adopcia/udaje/:kravicka_id?',
            name: 'adopcia-udaje',
            component: AdopciaUdaje,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/adopcia/ean/:kravicka_id?',
            name: 'adopcia-ean',
            component: AdopciaEan,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        /*{
            path: '/adopcia/info/:kravicka_id?',
            name: 'adopcia-info',
            component: AdopciaInfo,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },*/


    // Album
        {
            path: '/album/uspechy',
            name: 'album',
            component: AlbumUspechy,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/uspechy',
            name: 'album-uspechy',
            component: AlbumUspechy,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/kravicky',
            name: 'album-kravicky',
            component: AlbumKravicky,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/anatomia',
            name: 'album-anatomia',
            component: AlbumAnatomia,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/recepty',
            name: 'album-recepty',
            component: AlbumRecepty,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/recepty/:recept_id?',
            name: 'album-recepty-detail',
            component: AlbumReceptyDetail,
            props: true,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/omalovanky',
            name: 'album-omalovanky',
            component: AlbumOmalovanky,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },
        {
            path: '/album/videosekcia',
            name: 'album-videosekcia',
            component: AlbumVideosekcia,
            meta: {
                requiresAuth: false,
                showMenu: false
            },
        },

        // PEXESO
        {
            path: '/pexeso/landing/:kravicka_id',
            name: 'pexeso-landing',
            component: PexesoLanding
        },
        {
            path: '/pexeso/settings/:kravicka_id',
            name: 'pexeso-settings',
            component: PexesoSettings
        },
        {
            path: '/pexeso/game/:kravicka_id/:obtiaznost_id/:motiv_id',
            name: 'pexeso-game',
            component: PexesoGame
        },
        {
            path: '/pexeso/leaders/:kravicka_id',
            name: 'pexeso-leaders',
            component: PexesoLeaders
        },

        // SLIDER PUZZLE
        {
            path: '/slider/landing/:kravicka_id',
            name: 'slider-landing',
            component: SliderLanding
        },
        {
            path: '/slider/game/:kravicka_id/:obtiaznost_id/:motiv_id',
            name: 'slider-game',
            component: SliderGame
        },
        {
            path: '/slider/settings/:kravicka_id',
            name: 'slider-settings',
            component: SliderSettings
        },
        {
            path: '/slider/leaders/:kravicka_id',
            name: 'slider-leaders',
            component: SliderLeaders
        },
    ],


    // Extra
    linkActiveClass: "active",
    linkExactActiveClass: "exact-active",
})